import classnames from 'classnames';
import React, { Component } from 'react';
import { Select } from 'antd';
import { getString } from '@nackle/intl-tools';

import './language-picker.less';

export default class languagePicker extends Component {

    updateLanguage = async( locale ) => {
        const { updateLocale } = this.props;
        await updateLocale( locale );
    };

    getLocales = () => {
        let formattedLocales;
        if ( this.props.locales && this.props.locales.length > 0 ) {
            const filteredLocales = this.props.locales.filter( locale => {return locale.code !== 'ar-SA' && locale.code !== 'id-ID';} );
            formattedLocales = filteredLocales.map( locale => {
                return (
                    <Select.Option
                        key={ locale.code }
                        value={ locale.code }>
                        { locale.label }
                    </Select.Option>
                );
            } );
        }
        return formattedLocales;
    };

    render() {
        let {
            className,
            updateLocale,
            defaultLocale,
            userSelectedLocale,
            locale,
            ...props
        } = this.props;

        const selectedLocale = locale || userSelectedLocale || defaultLocale || 'en-US';

        return (
            <div className={ classnames( 'languagePickerContainer', className ) } { ...props }>
                <Select
                    aria-label={ getString( 'languagePicker.input.languagePickerAriaLabel' ) }
                    size="large"
                    data-testid="language-picker-dropdown"
                    bordered
                    style={ { width: '100%' } }
                    value={ selectedLocale }
                    onChange={ this.updateLanguage }
                >
                    { this.getLocales() }
                </Select>
            </div>
        );
    }
}